import loadable from '@loadable/component';

export const Component = loadable(
  () => import('./containers/SubscriptionParametersContainer')
);
export { default as propsFormatter } from './propsFormatter';
